export default __webpack_public_path__ + "static/media/Mitrabinda Bahere.c63bd6ab.jpg";